var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCloseThick = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 16,
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Isolation_Mode",
  clipPath: "url(#clip0_426_636)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12.5055 15.8771C11.8988 15.8771 11.3155 15.6271 10.8488 15.1521L1.51551 5.1521C0.605508 4.1771 0.605508 2.5771 1.51551 1.6021C2.42551 0.6271 3.91884 0.6271 4.82884 1.6021L14.1622 11.6021C15.0722 12.5771 15.0722 14.1521 14.1622 15.1271C13.6955 15.6271 13.1122 15.8521 12.5055 15.8521V15.8771Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M3.17217 15.8771C2.56551 15.8771 1.98217 15.6271 1.51551 15.1521C0.605508 14.1771 0.605508 12.6021 1.51551 11.6271L10.8488 1.6021C11.7588 0.6271 13.2288 0.6271 14.1388 1.6021C15.0488 2.5771 15.0488 4.1521 14.1388 5.1271L4.82884 15.1521C4.36217 15.6521 3.77884 15.8771 3.17217 15.8771Z",
  fill: "#414141"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_426_636"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 15,
  fill: "white",
  transform: "translate(0.838867 0.877197)"
})))));
export default SvgIconCloseThick;